<template>
  <div>
    <CModal
      :title="$t('editNetworkUser')"
      color="primary"
      centered
      :closeOnBackdrop="false"
      size="xl"
      :show.sync="$store.state.editNetworkUserModal.status"
      @update:show="changeShowStatus"
    >
      <template #header>
        <h6 class="modal-title">{{$t('editNetworkUser')}}</h6>
        <CButtonClose @click="() => {
          $store.commit('setEditNetworkUserModal', {status: false, userData: null})
          resetModal()
        }" class="text-white"/>
      </template>
      <CCard>
        <CCardBody>
          <CForm>
            <CRow>
              <CCol sm="12" md="6">
                <CInput
                  v-model="editUser.nombre"
                  :label="$t('name')"
                  :placeholder="$t('enterName')"
                  horizontal
                  :isValid="needValidation ? required:undefined"
                />
                <CInput
                  v-model="editUser.apellido"
                  :label="$t('lastName')"
                  :placeholder="$t('enterLastname')"
                  horizontal
                  :isValid="needValidation ? required:undefined"
                />
                <CSelect
                  :value.sync="editUser.sexo"
                  :label="$t('gender')"
                  horizontal
                  :options="[{label: $t('female'), value: 'Femenino'}, {label: $t('male'), value: 'Masculino'}]"
									:reduce="data => data.value"
                  :placeholder="$t('selectGender')"
                />
                <CInput
                  v-model="editUser.nacimiento"
                  :label="$t('birth')"
                  type="date"
                  :min="setDate(1)"
                  :max="setDate(2)"
                  :description="$t('birthDescription')"
                  horizontal
                  :isValid="needValidation ? required:undefined"
                />
                <CInput
                  v-model="editUser.email"
                  :label="$t('email')"
                  :placeholder="$t('enterEmail')"
                  type="email"
                  horizontal
                  :isValid="needValidation ? required && email:undefined"
                />
                <CInput
                  v-model="editUser.telefono"
                  :label="$t('phone')"
                  :placeholder="$t('enterPhone')"
                  horizontal
                  :isValid="needValidation ? required:undefined"
                />
              </CCol>
              <CCol>
                <div role="group" class="form-group form-row">
                  <label class="col-form-label col-sm-3"> {{$t('specialty')}} </label>
                  <div class="col-sm-9">
                    <v-select
                      :placeholder="$t('selectSpecialty')"
                      :options="especialties"
                      :reduce="data => data.value"
                      :clearable="false"
                      required
                      :isValid="needValidation ? required:undefined"
                      v-model="editUser.especialidad"></v-select>
                  </div>
                </div>
                <div role="group" class="form-group form-row">
                  <label class="col-form-label col-sm-3"> {{$t('job')}}</label>
                  <div class="col-sm-9">
                    <v-select
                      :placeholder="$t('selectJobType')"
											:options="[{label: $t('contract'), value: 'Dependiente'}, {label: $t('independent'), value: 'Independiente'}]"
											:reduce="data => data.value"
                      :clearable="false"
                      required
                      :isValid="needValidation ? required:undefined"
                      v-model="editUser.trabajo"></v-select>
                  </div>
                </div>
                <CInput
                  v-if="editUser.trabajo == 'Dependiente'"
                  v-model="editUser.empresa"
                  :label="$t('company')"
                  :placeholder="$t('enterCompany')"
                  horizontal
                  :isValid="needValidation ? required:undefined"
                />
                <CInput
                  v-model="editUser.direccion"
                  :label="$t('address')"
                  :placeholder="$t('enterAddress')"
                  horizontal
                  :isValid="needValidation ? required:undefined"
                />
                <div role="group" class="form-group form-row">
                  <label class="col-form-label col-sm-3"> {{$t('country')}} </label>
                  <div class="col-sm-9">
                    <v-select
                      :placeholder="$t('selectCountry')"
                      :options="$store.state.countries"
                      label="name"
                      :clearable="false"
                      :reduce="data => data.name"
                      @option:selected="(country) => {
                        getStates(country.id)
                        editUser.region = null
                        editUser.comuna = null
                      }"
                      required
                      :isValid="needValidation ? required:undefined"
                      v-model="editUser.pais"></v-select>
                  </div>
                </div>
                <div role="group" class="form-group form-row">
                  <label class="col-form-label col-sm-3"> {{$t('region')}} </label>
                  <div class="col-sm-9">
                    <v-select
                      :placeholder="$t('selectRegion')"
                      :options="$store.state.states"
                      label="name"
                      :clearable="false"
                      :reduce="data => data.name"
                      @option:selected="(state) => {
                        getComunas(state.id)
                        editUser.comuna = null
                      }"
                      :isValid="needValidation ? required:undefined"
                      v-model="editUser.region"></v-select>
                  </div>
                </div>
                <div role="group" class="form-group form-row">
                  <label class="col-form-label col-sm-3"> {{$t('comuna')}} </label>
                  <div class="col-sm-9">
                    <v-select
                      :placeholder="$t('selectComuna')"
                      :options="$store.state.comunas"
                      label="name"
                      :clearable="false"
                      :reduce="data => data.name"
                      :isValid="needValidation ? required:undefined"
                      v-model="editUser.comuna"></v-select>
                  </div>
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="12">
								<h5 class="bg-primary text-white text-center py-2">{{ $t('moveCreditsTitle') }}</h5>
                <CInput
                  v-model="creditosUser"
									type="number"
                  :label="$t('credits')"
                  :placeholder="$t('enterCredits')"
                  :description="$t('changeCreditsDescription')"
                  horizontal
                >
									<template #append>
										<CButton color="primary" size="sm" @click="modifyCredits" :disabled="loading"><CIcon name="cil-check-circle"/> {{$t('modify')}}</CButton>
									</template>
								</CInput>
              </CCol>
            </CRow>
          </CForm>
        </CCardBody>
      </CCard>
      <div slot="footer" class="d-flex align-items-center justify-end">
        <CBadge v-if="showRequiredAlert" color="warning" class="mx-2 px-2 py-1 text-white"><CIcon name="cil-bell"/> {{$t('allFieldsRequired')}}</CBadge>
        <CButton type="submit" color="primary" @click="sendForm" :disabled="loading"><CIcon name="cil-check-circle"/> {{$t('editUser')}}</CButton>
      </div>
    </CModal>
  </div>
</template>

<script>
import {required, email} from '@/helpers/validators'
import {getCountries, getStates, getComunas} from '@/helpers/api/regionalization.js'
import {editUser, modifyCredits} from '@/helpers/api/users.js'

export default {
  name: 'EditNetworkUserModal',
  data () {
    return {
      needValidation: false,
      showRequiredAlert: false,
      loading: false,
      especialties: [
				{label: this.$i18n.t('jobTypeA'), value:'Entrenador'},
				{label: this.$i18n.t('jobTypeB'), value:'Preparador Físico'},
				{label: this.$i18n.t('jobTypeC'), value:'Prof. Educ. Física'},
				{label: this.$i18n.t('jobTypeD'), value:'Kinesiólogo'},
				{label: this.$i18n.t('jobTypeE'), value:'Nutricionista'},
				{label: this.$i18n.t('jobTypeF'), value:'Cirujano Plástico'},
				{label: this.$i18n.t('jobTypeG'), value:'Bariatra'},
				{label: this.$i18n.t('jobTypeH'), value:'Masoterapeuta'},
				{label: this.$i18n.t('jobTypeI'), value:'Masajista'},
				{label: this.$i18n.t('jobTypeJ'), value: 'Médico General'},
				{label: this.$i18n.t('jobTypeK'), value: 'Nutriólogo'},
				{label: this.$i18n.t('jobTypeL'), value: 'Cardiólogo'},
				{label: this.$i18n.t('jobTypeM'), value: 'Diabetólogo'},
				{label: this.$i18n.t('jobTypeN'), value: 'Psicólogo'},
				{label: this.$i18n.t('jobTypeO'), value: 'Otra especialidad médica'},
			],
			creditosUser: 0,
      editUser: {
				id_usuario: null,
        nombre: '',
        apellido: '',
        email: '',
        telefono: '',
        nacimiento: null,
        sexo: 'Femenino',
        img_url: 'defecto.png',
        direccion: '',
        pais: null,
        region: null,
        comuna: null,
        especialidad: null,
        trabajo: null,
        empresa: null,
      }
    }
  },
  watch: {
    '$store.state.editNetworkUserModal': {
      immediate: true,
      handler (editNetworkUserModal) {
        if(editNetworkUserModal && editNetworkUserModal.status && editNetworkUserModal.userData && editNetworkUserModal.userData.profile){
          this.getUserToEdit()
        }
      }
    }
  },
  mounted(){
    this.getCountries()
  },
  methods: {
    required, email,
		async getUserToEdit(){
			Object.keys(this.editUser).forEach(key => {
				this.editUser[key] = this.$store.state.editNetworkUserModal.userData.profile[key]
			})
			this.creditosUser = this.$store.state.editNetworkUserModal.userData.creditos
		},
    setDate(type){
      let date = new Date()
      if(type == 1){
        date.setFullYear( date.getFullYear() - 100 )
      }
      else{
        date.setFullYear( date.getFullYear() - 13 )
      }
      return date.toISOString().split("T")[0]
    },
    changeShowStatus(status){
      this.resetModal()
    },
    resetModal(){
      this.needValidation = false
      this.showRequiredAlert = false
      this.loading = false
      this.editUser = {
				id_usuario: null,
        nombre: '',
        apellido: '',
        email: '',
        telefono: '',
        nacimiento: null,
        sexo: 'Femenino',
        img_url: 'defecto.png',
        direccion: '',
        pais: null,
        region: null,
        comuna: null,
        especialidad: null,
        trabajo: null,
        empresa: null,
      }
			this.$store.commit('setStates', [])
			this.$store.commit('setComunas', [])
    },
    async getCountries(){
      const countries = await getCountries()
      if(countries.countries){
        this.$store.commit('setCountries', countries.countries)
      }
    },
    async getStates(country_id){
      const states = await getStates({country_id})
      if(states.states){
        this.$store.commit('setStates', states.states)
      }
    },
    async getComunas(state_id){
      const comunas = await getComunas({state_id})
      if(comunas.cities){
        this.$store.commit('setComunas', comunas.cities)
      }
    },
    isValidForm(){
      this.needValidation = true
      return Object.keys(this.editUser).every((key) => {
				// console.log(key + ': ' + this.editUser[key] + ' ' + !!this.editUser[key] || ( this.editUser.trabajo == 'Independiente' && key == 'empresa' ))
        return !!this.editUser[key] || ( this.editUser.trabajo == 'Independiente' && key == 'empresa' )
      })
    },
    async sendForm(){
      if(this.isValidForm()){
        let completed = false
        this.loading = true
        const user = await editUser(this.editUser)
        if(user.data){
          this.$store.dispatch('getUsersList', {type: 1})
					this.$store.commit('setEditNetworkUserModal', {status: false, userData: null})
					this.resetModal()
					completed = true
        }

        this.$store.commit('addToast', {
          color: completed ? 'success':'warning',
          header: completed ? this.$i18n.t('editedUser'):'Error',
          message: completed ? this.$i18n.t('okEditUser'):this.$i18n.t('errorMessage')
        })
        this.loading = false
      }
      else{
        this.showRequiredAlert = true
      }
    },
		async modifyCredits(){
			let completed = false
			if(this.creditosUser != this.$store.state.editNetworkUserModal.userData.creditos){
				const data = {
					user_id: this.$store.state.userData.id_usuario,
					id_usuario: this.$store.state.editNetworkUserModal.userData.id,
					creditos: this.creditosUser,
				}
				const response = await modifyCredits(data)
				completed = true
				this.$store.dispatch('getEvaluatorsList', {type: 1})
			}
			this.$store.commit('addToast', {
				color: completed ? 'success':'warning',
				header: completed ? this.$i18n.t('okCreditsTitle'):'Error',
				message: completed ? this.$i18n.t('okCredits'):this.$i18n.t('errorMessage')
			})
		}
  }
}
</script>